import { render, staticRenderFns } from "./modal-change-password.html?vue&type=template&id=0e94c58d&scoped=true&"
import script from "./modal-change-password.js?vue&type=script&lang=js&"
export * from "./modal-change-password.js?vue&type=script&lang=js&"
import style0 from "./modal-change-password.scss?vue&type=style&index=0&id=0e94c58d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e94c58d",
  null
  
)

export default component.exports